export default "__VITE_ASSET__CwNYh12M__"